import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Create your Slack Workspace`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create a Slack workspace by going to `}<a parentName="p" {...{
            "href": "https://slack.com/get-started#/createnew"
          }}>{`https://slack.com/get-started#/createnew`}</a>{` and logging in with an email `}<i><strong parentName="p">{`which is not your IBM email`}</strong></i>{`. Your IBM email is part of the IBM Slack enterprise account and you will not be able to create an independent Slack workspace outside if the IBM slack service. `}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack1.png",
          "alt": "slack1"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After authentication, you will see the following screen:`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack2.png",
          "alt": "slack2"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Create a Workspace`}</strong>{` ->`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Name your Slack workspace`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack3.png",
          "alt": "slack3"
        }}></img>
        <p parentName="li">{` Give your workspace a unique name such as aiops-\\<yourname`}{`>`}{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Describe the workspace current purpose`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack4.png",
          "alt": "slack4"
        }}></img>
        <p parentName="li">{` This is free text, you may simply write “demo for CloudPak for AIOps” or whatever you like.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add team members`}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack5.png",
          "alt": "slack5"
        }}></img>
        <p parentName="li">{` You may add team members to your new Slack workspace or skip this step.`}</p>
      </li>
    </ol>
    <p>{`At this point you have created your own Slack workspace where you are the administrator and can perform all the necessary steps to integrate with CP4WAOps.`}</p>
    <img {...{
      "src": "./../images/slack/slack6.png",
      "alt": "slack6"
    }}></img>
    <blockquote>
      <p parentName="blockquote">{`❗ This Slack workspace is outside the control of IBM and must be treated as a `}<strong parentName="p">{`completely public environment`}</strong>{`. Do not place any confidential material in this Slack workspace.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      